<template>
  <div class="cont" id="cont5">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:35px;width:168px;margin-left:73px;margin-bottom:12px"
        :src="require('@/assets/image/home/home5/img1.png')"
        :fit="fit"
      ></el-image>

      <router-link :to="{ path: '/moment/newsActivities'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:138px;margin-left:55px;margin-bottom:9px"
          :src="require('@/assets/image/home/home5/img2.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <router-link :to="{ path: '/moment/wonderfulVideo'  }">
        <el-image 
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:136px;margin-left:43px;margin-bottom:10px"
          :src="require('@/assets/image/home/home5/img3.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <router-link :to="{ path: '/moment/Image'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:22px;width:137px;margin-left:28px;margin-bottom:34px"
          :src="require('@/assets/image/home/home5/img4.png')"
          :fit="fit"
        ></el-image>
      </router-link>

      <router-link :to="{ name: 'Moment'  }">
        <el-image
          :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
          style="height:29px;width:137px;margin-left:0px;margin-bottom:0px;display:block"
          :src="require('@/assets/image/home/home5/img5.png')"
          :fit="fit"
        ></el-image>
      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContFive",
  data() {
    return {
      fit: "cover",
      animate: false,
      screenHeight: window.innerHeight || document.documentElement.clientHeight
    };
  },
  mounted() {
    // 事件监听滚动条
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    var topPos = document.getElementById("cont5").offsetTop;
    if (scrollTop + this.screenHeight > topPos) {
      this.animate = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var topPos = document.getElementById("cont5").offsetTop;
      if (scrollTop + this.screenHeight > topPos) {
        this.animate = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  position: relative;
  background: url('~@/assets/image/home/home5/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.inner {
  position: absolute;
  width: 241px;
  height: 195px;
  right: 223px;
  top: 87px;
}
</style>